import { Progress } from "@/components/ui/progress";

export interface ImportingProgressProps {
  index: number;
  total: number;
  retrying?: boolean;
}

/**
 * The "importing run X of N" state shown on the progress card while a Strava
 * backfill streams in. Coverage reveals on the map as each run is matched.
 */
export const ImportingProgress = ({
  index,
  total,
  retrying,
}: ImportingProgressProps) => {
  const pct = total > 0 ? Math.min((index / total) * 100, 100) : 0;

  return (
    <div className="pt-5">
      <div className="mb-2 flex items-baseline justify-between gap-2">
        <span className="text-lg font-medium">
          {retrying ? "Paused, retrying soon" : "Importing your runs"}
        </span>
        {total > 0 && (
          <span className="text-sm text-muted-foreground">
            run {index} of {total}
          </span>
        )}
      </div>
      <Progress value={pct} className="mb-2 h-2" />
      <p className="text-sm text-muted-foreground">
        {retrying
          ? "Strava is rate limiting us; this will resume automatically."
          : "Your map fills in as each run is matched."}
      </p>
    </div>
  );
};
